import { connect } from 'react-redux';
import { onChange, onChangeClasses, onChangeInformation, onChangeItem } from './../../../../../actions/addOrder';
import OrderInformationComponent from './../../../components/order-information';
import './styles.css';

class OrderInformation extends OrderInformationComponent {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.loadChannel()
        this.getFulfillDefault();
    }
}

const mapStateToProps = state => {
    return {
        classes: state.addOrder.classes,
        information: state.addOrder.information,
        order: state.addOrder
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeInformation: payload => {
            dispatch(onChangeInformation(payload))
        },
        onChangeClasses: payload => {
            dispatch(onChangeClasses(payload))
        },
        onChange: payload => {
            dispatch(onChange(payload))
        },
        onChangeItem: payload => {
            dispatch(onChangeItem(payload))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderInformation)


// WEBPACK FOOTER //
// ./src/containers/orders/add/components/order-information/index.js